<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class=" col-sm-12">
            <div class="">
                <h6 class="f-w-700 pb-1">{{ t('Product Number') }} : {{ compState.productNumber }}</h6>
            </div>
        </div>
        <div class="col-sm-6">
            <label>
                <h6 class="f-w-700">{{ t('Department') }}</h6>
            </label>
            <select class="form-select" :aria-label="t('Department')" v-model="compState.department">
                <option value="" disabled>{{ t('Department') }}</option>
                <template v-for="department in departmentList" :key="department.id">
                    <option :value="department.name">{{ department.name }}</option>
                </template>
            </select>
        </div>

        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Product Name') }}</h6>
                </label>
                <input v-model="compState.name" class="form-control" type="text" :placeholder="t('Name')" maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Barcode') }}</h6>
                </label>
                <input v-model="compState.barcode" class="form-control" type="text" :placeholder="t('Name')" maxlength="128">
            </div>
        </div>
        <div class="col-sm-6">

        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Tax Rate') }}</h6>
                </label>
                <select v-model="compState.taxRate" class="form-select" :aria-label="t('Tax Rate')">
                    <option value="" disabled>{{ t('Tax Rate') }}</option>
                    <option v-for="tax in taxList.filter(t => !t.serviceCharge)" :key="String(tax.id)" :value="tax.name" >
                        {{ tax.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Service Charge') }}</h6>
                </label>
                <select v-model="compState.serviceCharge" class="form-select" :aria-label="t('Service Charge')">
                    <option value="" disabled>{{ t('Service Charge') }}</option>
                    <option v-for="tax in taxList.filter(t => t.serviceCharge)" :key="String(tax.id)" :value="tax.name" >
                        {{ tax.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Alternative Product Name') }}</h6>
                </label>
                <input v-model="compState.alternateName" class="form-control" type="text" :placeholder="t('Name')"
                    maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Alternative Product Name 2') }}</h6>
                </label>
                <input v-model="compState.alternateName2" class="form-control" type="text" :placeholder="t('Name')"
                    maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('Alternative Display Language') }}</h6>
                </label>
                <input class="form-control" type="text" :placeholder="t('Alternative Display Language')"
                    v-model="compState.altLangText" maxlength="32" readonly data-bs-toggle="modal"
                    data-original-title="test" data-bs-target="#alt-lang-modal">
            </div>
        </div>
        <div class="col-sm-6">

        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">{{ t('Display Order') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')" v-model="compState.displayOrder">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="displayOrderDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="displayOrderIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">{{ t('Empty Button') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')" v-model="compState.emptyBtn">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="displayEmptyBtnDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="displayEmptyBtnIncrement">+</button>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Single-Item-Select" type="checkbox" value=""
                        v-model="compState.singleItemSale">
                    <label class="form-check-label" for="Single-Item-Select">{{ t('Single Item Select') }}</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Show-on-Menu" type="checkbox" value=""
                        v-model="compState.showOnMenu">
                    <label class="form-check-label" for="Show-on-Menu">{{ t('Show on Menu') }}</label>
                </div>
            </div>
        </div>
    </div>
    <productAltLangModal @on-save="onEditAltLang" />
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import { useTaxesStore } from '@/store/management/taxesStore';
import type { Product } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productBasicLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productBasicLanguage
})

const productAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productAltLangModal.vue'))

const productStore = useProductsStore()

const taxesStore = useTaxesStore();

onMounted(() => {
    taxesStore.initializeTaxes();
});

const taxList = computed(() => taxesStore.getTaxesList);

onMounted(() => {
    taxesStore.initializeTaxes();
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.emptyBtn = basicData.emptyBtn
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
})

const compState = reactive({
    department: '',
    productNumber: '',
    name: '',
    barcode: '',
    taxRate: '',
    serviceCharge: '',
    alternateName: '',
    alternateName2: '',
    displayOrder: 0,
    emptyBtn: 0,
    singleItemSale: false,
    showOnMenu: false,
    altLangText: ''
})

const departmentList = computed(() => {
    return productStore.getDepartmentList
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}
watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.emptyBtn = basicData.emptyBtn
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        basic: {
            ...tempActiveProduct.value.basic,
            department: newVal.department,
            productNumber: newVal.productNumber,
            name: newVal.name,
            barcode: newVal.barcode,
            taxRate: newVal.taxRate,
            serviceCharge: newVal.serviceCharge,
            alternateName: newVal.alternateName,
            alternateName2: newVal.alternateName2,
            displayOrder: newVal.displayOrder,
            emptyBtn: newVal.emptyBtn,
            singleItemSale: newVal.singleItemSale,
            showOnMenu: newVal.showOnMenu
        }
    } as Product)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const displayEmptyBtnIncrement = () => {
    compState.emptyBtn++
}

const displayEmptyBtnDecrement = () => {
    if (compState.emptyBtn > 0) {
        compState.emptyBtn--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
}

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>